@if (!embeddedComponent) {
    <sm-toolbar>
        <p-button severity="success" icon="fas fa-save" [label]="app.t('general.save')" (onClick)="save()">
        </p-button>
        <p-button severity="secondary" icon="fas fa-times" [label]="app.t('general.cancel')" (onClick)="close()">
        </p-button>
        @if (isInsert()) {
            <p-checkbox [appLabel]="app.t('entity.Project.other.multiInsertMode')" [binary]=true [(ngModel)]="multiInsert"></p-checkbox>
        }
    </sm-toolbar>
}
<div class="form-container">
    <p-card>
        <sm-form [form]="form">
        </sm-form>
        <app-edit-calendar-outline-template-table #table [forProject]=true></app-edit-calendar-outline-template-table>
    </p-card>
</div>
